module.exports = __webpack_public_path__ + "static/img/s1021.90cded6f.png";